import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["emotion"];
import React from 'react';
import PropTypes from 'prop-types';
import Amazed from '../../assets/images/dolphin-svgs/amazed.svg';
import Angry from '../../assets/images/dolphin-svgs/angry.svg';
import Concerned from '../../assets/images/dolphin-svgs/concerned.svg';
import Confused from '../../assets/images/dolphin-svgs/confused.svg';
import Excited from '../../assets/images/dolphin-svgs/excited.svg';
import ExcitedGreyBackground from '../../assets/images/dolphin-svgs/excitedGreyBackground.svg';
import Happy from '../../assets/images/dolphin-svgs/happy.svg';
import Paranoid from '../../assets/images/dolphin-svgs/paranoid.svg';
import Waiting from '../../assets/images/dolphin-svgs/waiting.svg';
export default function Dolphin(_ref) {
  var emotion = _ref.emotion,
      props = _objectWithoutProperties(_ref, _excluded);

  var dolphinEmotions = {
    amazed: Amazed,
    angry: Angry,
    concerned: Concerned,
    confused: Confused,
    excited: Excited,
    excitedGreyBackground: ExcitedGreyBackground,
    happy: Happy,
    paranoid: Paranoid,
    waiting: Waiting
  };
  return /*#__PURE__*/React.createElement("img", _extends({
    src: dolphinEmotions[emotion],
    alt: emotion
  }, props));
}
Dolphin.propTypes = {
  emotion: PropTypes.string
};
Dolphin.defaultProps = {
  emotion: 'happy'
};